import { Hotel } from 'schema-dts';
import { jsonLdScriptProps } from 'react-schemaorg';
import Script from 'next/script';

import { HotelDetailViewModel, PackageHotelDetailViewModel } from '@api/v3';
import { getHotelDetailChildAndVariationsInfo } from '@utils/utils';
import { cloudineryImage } from '@components/views/hotel/detail/utils/features';
import useGetasPath from '@hooks/useGetasPath';

export const HotelDetailSchemaOrg = ({
  hotelDetail,
}: {
  hotelDetail: HotelDetailViewModel | PackageHotelDetailViewModel;
}) => {
  const asPath = useGetasPath();
  const url = `${process.env.NEXT_PUBLIC_HOST}${asPath}`;
  const {
    variations: [variationWithMinPrice, variationWithMaxPrice],
  } = getHotelDetailChildAndVariationsInfo(hotelDetail);
  const priceRange =
    variationWithMinPrice && variationWithMaxPrice
      ? variationWithMinPrice?.variation?.totalSellingPrice +
        ' - ' +
        variationWithMaxPrice?.variation?.totalSellingPrice
      : '';
  return (
    <Script
      defer
      {...jsonLdScriptProps<Hotel>({
        '@context': 'https://schema.org',
        '@type': 'Hotel',
        name: hotelDetail.name,
        url,
        image: cloudineryImage(hotelDetail.images?.[0]?.url, 820, 404) || '',
        description: hotelDetail.metaDescription,
        priceRange,
        telephone: '+90-216-554-3700', //call center phone number.
        address: [
          {
            '@type': 'PostalAddress',
            addressCountry: hotelDetail.countryCode,
            addressLocality: hotelDetail.city,
            streetAddress: hotelDetail.address,
          },
        ],
        photo: hotelDetail.images?.map((hotelImage) => ({
          '@type': 'ImageObject',
          contentUrl: hotelImage.url,
          description: hotelImage.hotelImageCategoryName,
        })),
        amenityFeature: hotelDetail.features?.map((feature) => ({
          '@type': 'LocationFeatureSpecification',
          value: 'true', //static value.
          name: feature.name,
        })),
      })}
    />
  );
};
